export var SHARE_BUTTON_NAMES = {
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    LINKEDIN: 'linkedin',
};
export var BI_ORIGINS = {
    MEMBERS_AREA: 'members area',
    WIDGET: 'widget',
    EVENT_DETAILS: 'event details',
    THANK_YOU_PAGE: 'thank you page',
};
export var BI_ENDPOINTS = {
    EVENTS_UOU: 'events-uou',
    EVENTS_USERS: 'events-users',
};
//# sourceMappingURL=constants.js.map